/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'
import { useFormikContext, ErrorMessage } from 'formik'
import { useTranslation } from 'react-i18next'

interface ErrorMessageStyledProps {
  name: string
  classesName?: string
}

export const ErrorMessageStyled: React.FC<ErrorMessageStyledProps> = ({ name, classesName = '' }) => {
  const { t } = useTranslation()

  return (
    <ErrorMessage name={name}>
      {(msg: string) => <div className={`${classesName} text-danger`}>{t(msg)}</div>}
    </ErrorMessage>
  )
}

interface CustomErrorMessageProps {
  name: string
  isErrMsgAObj?: boolean
}

const CustomErrorMessage: React.FC<CustomErrorMessageProps> = ({ name, isErrMsgAObj = false }) => {
  const { t } = useTranslation()
  const formikContext = useFormikContext()

  return (
    formikContext.submitCount > 0 && (
      <ErrorMessage name={name}>
        {(msg: any) => {
          return <div className="text-danger">{t(isErrMsgAObj ? msg?.name : msg)}</div>
        }}
      </ErrorMessage>
    )
  )
}

export default CustomErrorMessage
